export const getAccessToken = (): string | null =>
  localStorage.getItem('access-Token-Edify')
